import React, { useEffect } from 'react';
import useStyles from './Login.styles';
import { Box, Typography, SvgIcon } from '@material-ui/core';
import RedbullIcon from '../../assets/images/redbullIcon/RedbullIcon';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import RedbullLogoIcon from '../../assets/images/redbullIcon/RedBullLogoIcon';

const ExpiredPasswordReset = () => {
  const styles = useStyles();

  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'WNDR password reset';
    return () => {
      document.title = 'WNDR admin panel';
    };
  }, []);

  return (
    <Box className={styles.background}>
      <Box className={styles.loginForm}>
        <Box alignSelf="center" margin={1} py={1}>
          {/* <SvgIcon component={RedbullIcon} /> */}
          <RedbullLogoIcon />
        </Box>
        <Box marginTop={1}>
          <Typography variant="h6">{t(tPaths.passwordReset.passwordReset)}</Typography>
          <Box marginTop={2}>
            <Typography variant="subtitle2">{t(tPaths.passwordReset.expired)}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ExpiredPasswordReset;
